import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import {Input} from './input/Base';
import { FormControl, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Util, createIcon } from '../common';
import SubdirectoryArrowLeftIcon from '@material-ui/icons/SubdirectoryArrowLeft';
import Tooltip from './Tooltip';

function FloatFormat(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator={false}
        isNumericString
      />
    );
  }
  
  FloatFormat.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  };


  function IntFormat(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        decimalScale={0}
        thousandSeparator={false}
        isNumericString
      />
    );
  }
  
  IntFormat.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  };


export class TextBox extends Input {
   
    constructor(props) {
        super(props);
        this.state={
            ...this.state,
            value:''
        }
        this.value='';
    }

    get() {
        return this.value;
    }

    set(v) {
        if(this.value ==v) return; //paper里设置时会用到这判断，避免重复设置
        this.value = v;
        this.setState({value:v});
    }

    reset() {
        super.reset();
        this.set('');
    }

    ignore(b) { //忽略项，这个方法会将组件隐藏，并且不参与form行为
        // var o = this, oj = this.getJquery();
        // if (b) {
        //     o.ignoreForm = true;
        //     oj.hide();
        // } else {
        //     o.ignoreForm = false;
        //     oj.show();
        // }
    }

    handleBlur(e){
        let {onBlur} = this.props;
        // this.validate();
        if(onBlur) onBlur(e);
    }

    handleFocus(e){
      let {onFocus} = this.props;
      if(onFocus) onFocus(e);
    }

    defaultErrorMessage(type){
        let {minlength,maxlength}=this.props;
        let call = this.call();
        switch(type){
            case "minlength":{
                return `${call}字数不能小于${minlength}`;
            }
            case "maxlength":{
                return `${call}字数不能大于${maxlength}`;
            }
            case "variable":{
              return `${call}只能包含英文、数字和下划线`;
          }
        }
        return super.defaultErrorMessage(type);
    }


    getInputProps(){
        var p = super.getInputProps();
        let {type,rowsMax,variant} = this.props;
        if(type == "float"){
            p.inputComponent = FloatFormat;
        }else if(type == "int"){
            p.inputComponent = IntFormat;
        } else if(rowsMax > 1 && variant==="standard"){
            p.endAdornment = <InputAdornment position="end">{createIcon(SubdirectoryArrowLeftIcon,"c-text-s3 m-text-dark-50")}</InputAdornment>;
        }
        
        return p;
    }

    getInputType(){
      let {type} = this.props;
      switch(type){
        case "hidden": return "hidden";
        case "text": return "text";
      }
      return type;
    }

    getAutoComplete(){
      let {autoComplete} = this.props;
      if(autoComplete===false) return "new-password";
      return "on";
    }

    getReceiveFocus(){ //获得用于接收焦点的组件
      return this.refs.input.getElementsByTagName("input")[0];
    }

    renderInput(className){
      let {label,placeholder,help,rowsMax,required,variant,rows,full,autoComplete,size,width} = this.props;
      let {value,error}=this.state;
      let inputType = this.getInputType();
      let style =width?{width}:{};
      return <TextField
                style={{...style}}
                ref="input"
                autoComplete={this.getAutoComplete()}
                required={required?true:false}
                variant={variant}
                key={1}
                className={className}
                error={error?true:false}
                size={size}
                type={inputType}
              
                disabled={this.disabled()}
                placeholder={placeholder}
                helperText={error||help}
                label={label}
                multiline={(rowsMax>1 || rows>1 || full)?true:false}
                rows={rows}
                rowsMax={rowsMax||rows||1}
                margin="none"
                value={value||''}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={this.getInputProps()}
                onChange={(e)=>{ this.handleChange(e.target.value); }} 
                onBlur={(e)=>{this.handleBlur(e)}}
                onFocus={(e)=>{this.handleFocus(e)}}
                fullWidth
            />
    }

    renderMain(title,className,width){
      return title?<FormControl className={`${width?'':'w-100'} ${className}`}>{[title,this.renderInput('')]}</FormControl>:this.renderInput(className);
    }

    render() {
        let {type,full,width} = this.props;
        let className = this.getClassName(type=="hidden"?"c-input-hidden":"");
        let title = this.tipComponent("textBox",{ignore:true},0);
        className = `${full?'c-input-full':''} ${className} `;
        let tip = this.getTip();
        if(!tip){
          return this.renderMain(title,className,width);
        }
        return (
          Tooltip({
            description:tip,
            placement:"top",
            content:(<div className={`${width?'':'w-100'}`}>{this.renderMain(title,className,width)}</div>)
        })
        )
    }
  }
  
  TextBox.defaultProps = {
    type:"text",
    variant:"outlined", //"standard",
    size:"medium",
    rows:null,
    className:'',
    autoComplete:true,
    width:0
  }



export class Password extends TextBox {
    
  constructor(props) {
    super(props);
    this.state={
        ...this.state,
        showPassword: false
    }
  }


  getInputType(){
    let { showPassword } = this.state;
    return showPassword ? "text" : "password";
  }

  getInputProps(){
    var p = super.getInputProps();
    p.endAdornment = this.getPasswordAdornment();
    return p;
  }

  handleClickShowPassword(){
    let { showPassword } = this.state;
    this.setState({
      showPassword: !showPassword
    });
  }

  handleMouseDownPassword(e){
    e.preventDefault();
  };

  getPasswordAdornment(){
    let { showPassword } = this.state;
    return(
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => { this.handleClickShowPassword(); }}
          onMouseDown={(e) => { this.handleMouseDownPassword(e); }}
        >
          {showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    )
  }
}